"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isSoilTypesLoaded = isSoilTypesLoaded;
exports.isAdsLoaded = isAdsLoaded;
exports.isAdLoaded = isAdLoaded;
exports.loadSoilTypes = loadSoilTypes;
exports.loadAds = loadAds;
exports.loadAd = loadAd;
exports.createAd = createAd;
exports.updateAd = updateAd;
exports.sendAdMessage = sendAdMessage;
exports.resetCreateAd = resetCreateAd;
exports.resetUpdateAd = resetUpdateAd;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_SOIL_TYPES = "maaporssi/ads/LOAD_SOIL_TYPES";
var LOAD_SOIL_TYPES_FAIL = "maaporssi/ads/LOAD_SOIL_TYPES_FAIL";
var LOAD_SOIL_TYPES_SUCCESS = "maaporssi/ads/LOAD_SOIL_TYPES_SUCCESS";

var CREATE_AD = "maaporssi/ads/CREATE_AD";
var CREATE_AD_FAIL = "maaporssi/ads/CREATE_AD_FAIL";
var CREATE_AD_SUCCESS = "maaporssi/ads/CREATE_AD_SUCCESS";
var CREATE_AD_RESET = "maaporssi/ads/CREATE_AD_RESET";

var UPDATE_AD = "maaporssi/ads/UPDATE_AD";
var UPDATE_AD_FAIL = "maaporssi/ads/UPDATE_AD_FAIL";
var UPDATE_AD_SUCCESS = "maaporssi/ads/UPDATE_AD_SUCCESS";
var UPDATE_AD_RESET = "maaporssi/ads/UPDATE_AD_RESET";

var LOAD_ADS = "maaporssi/ads/LOAD_ADS";
var LOAD_ADS_SUCCESS = "maaporssi/ads/LOAD_ADS_SUCCESS";
var LOAD_ADS_FAIL = "maaporssi/ads/LOAD_ADS_FAIL";

var LOAD_AD = "maaporssi/ads/LOAD_AD";
var LOAD_AD_SUCCESS = "maaporssi/ads/LOAD_AD_SUCCESS";
var LOAD_AD_FAIL = "maaporssi/ads/LOAD_AD_FAIL";

var SEND_AD_MESSAGE = "maaporssi/ads/SEND_AD_MESSAGE";
var SEND_AD_MESSAGE_FAIL = "maaporssi/ads/SEND_AD_MESSAGE_FAIL";
var SEND_AD_MESSAGE_SUCCESS = "maaporssi/ads/SEND_AD_MESSAGE_SUCCESS";
var SEND_AD_MESSAGE_RESET = "maaporssi/ads/SEND_AD_MESSAGE_RESET";

var initialState = {
  soilTypesLoaded: false,
  adsLoaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SOIL_TYPES:
      return (0, _extends3.default)({}, state, {
        soilTypesLoading: true
      });
    case LOAD_SOIL_TYPES_FAIL:
      return (0, _extends3.default)({}, state, {
        soilTypesLoading: false,
        soilTypesLoaded: true,
        error: action.error.error
      });
    case LOAD_SOIL_TYPES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        soilTypesLoading: false,
        soilTypesLoaded: true,
        soilTypes: action.result
      });

    case CREATE_AD:
      return (0, _extends3.default)({}, state, {
        createAdLoading: true
      });
    case CREATE_AD_FAIL:
      return (0, _extends3.default)({}, state, {
        createAdLoading: false,
        createAdSuccess: false,
        createAdError: action.error.error
      });
    case CREATE_AD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        ad: action.result,
        createAdLoading: false,
        createAdSuccess: true,
        createAdError: null
      });
    case CREATE_AD_RESET:
      return (0, _extends3.default)({}, state, {
        ad: null,
        createAdLoading: false,
        createAdSuccess: false,
        createAdError: null
      });

    case UPDATE_AD:
      return (0, _extends3.default)({}, state, {
        updateAdLoading: true
      });
    case UPDATE_AD_FAIL:
      return (0, _extends3.default)({}, state, {
        updateAdLoading: false,
        updateAdSuccess: false,
        updateAdError: action.error.error
      });
    case UPDATE_AD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        updateAdLoading: false,
        updateAdSuccess: true,
        updateAdError: null,
        ads: state.ads.map(function (ad) {
          if (ad.id === action.result.id) {
            return (0, _assign2.default)({}, action.result, { isLoaded: true, editable: true });
          } else {
            return ad;
          }
        })
      });
    case UPDATE_AD_RESET:
      return (0, _extends3.default)({}, state, {
        updateAdLoading: false,
        updateAdSuccess: false,
        updateAdError: null
      });
    // MRÈSSAGES
    case SEND_AD_MESSAGE:
      return (0, _extends3.default)({}, state, {
        sendAdMessageLoading: true
      });
    case SEND_AD_MESSAGE_FAIL:
      return (0, _extends3.default)({}, state, {
        sendAdMessageLoading: false,
        sendAdMessageSuccess: false,
        sendAdMessageError: action.error.error
      });
    case SEND_AD_MESSAGE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        sendAdMessageLoading: false,
        sendAdMessageSuccess: true,
        sendAdMessageError: null,
        sendAdMessageResponse: action.result
      });
    case SEND_AD_MESSAGE_RESET:
      return (0, _extends3.default)({}, state, {
        sendAdMessageLoading: false,
        sendAdMessageSuccess: false,
        sendAdMessageError: null
      });

    case LOAD_ADS:
      return (0, _extends3.default)({}, state, {
        adsLoading: true
      });
    case LOAD_ADS_FAIL:
      return (0, _extends3.default)({}, state, {
        adsLoading: false,
        adsLoaded: true,
        adsError: action.error.error
      });
    case LOAD_ADS_SUCCESS:
      var ads = action.result.map(function (ad) {
        var loadedAd = state.ads && state.ads.find(function (stateAd) {
          return stateAd.isLoaded && stateAd.id === ad.id;
        });
        return loadedAd || ad;
      });
      return (0, _extends3.default)({}, state, {
        adsLoading: false,
        adsLoaded: true,
        adsError: null,
        ads: ads
      });

    case LOAD_AD:
      return (0, _extends3.default)({}, state, {
        adLoading: true
      });
    case LOAD_AD_FAIL:
      return (0, _extends3.default)({}, state, {
        adLoading: false,
        adError: action.error.error
      });
    case LOAD_AD_SUCCESS:
      var allAds = void 0;
      if (state.ads) {
        allAds = state.ads.map(function (ad) {
          if (ad.id === action.result.id) {
            return (0, _assign2.default)({}, ad, action.result, { isLoaded: true });
          } else {
            return ad;
          }
        });
      } else {
        allAds = [action.result];
      }
      return (0, _extends3.default)({}, state, {
        ads: allAds,
        adLoading: false,
        adError: null
      });

    default:
      return state;
  }
}

function isSoilTypesLoaded(globalState) {
  return globalState.ads && globalState.ads.soilTypesLoaded;
}

function isAdsLoaded(globalState) {
  return globalState.ads && globalState.ads.adsLoaded;
}

function isAdLoaded(adId, globalState) {
  var ads = globalState && globalState.ads && globalState.ads.ads;
  if (ads && ads.length) {
    return ads.some(function (ad) {
      return ad.id === adId && ad.isLoaded;
    });
  }
}

function loadSoilTypes() {
  return {
    types: [LOAD_SOIL_TYPES, LOAD_SOIL_TYPES_SUCCESS, LOAD_SOIL_TYPES_FAIL],
    promise: function promise(client) {
      return client.get("/soil_types");
    }
  };
}

function loadAds() {
  return {
    types: [LOAD_ADS, LOAD_ADS_SUCCESS, LOAD_ADS_FAIL],
    promise: function promise(client) {
      return client.get("/ads");
    }
  };
}

function loadAd(id) {
  return {
    types: [LOAD_AD, LOAD_AD_SUCCESS, LOAD_AD_FAIL],
    promise: function promise(client) {
      return client.get("/ads/" + id);
    }
  };
}

function createAd(formData) {
  return {
    types: [CREATE_AD, CREATE_AD_SUCCESS, CREATE_AD_FAIL],
    promise: function promise(client) {
      return client.post("/ads", {
        data: formData
      });
    }
  };
}

function updateAd(id, formData) {
  return {
    types: [UPDATE_AD, UPDATE_AD_SUCCESS, UPDATE_AD_FAIL],
    promise: function promise(client) {
      return client.put("/ads/" + id, {
        data: formData
      });
    }
  };
}

function sendAdMessage(data) {
  console.info("sendAdMessage", data);
  return {
    types: [SEND_AD_MESSAGE, SEND_AD_MESSAGE_SUCCESS, SEND_AD_MESSAGE_FAIL],
    promise: function promise(client) {
      return client.post("/sm", {
        data: data
      });
    }
  };
}

function resetCreateAd() {
  return {
    type: CREATE_AD_RESET
  };
}

function resetUpdateAd() {
  return {
    type: UPDATE_AD_RESET
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/ads.js
 ** module id = 91
 ** module chunks = 0
 **/